<script setup>
  import {
    computed,
    nextTick,
    onMounted,
    ref,
  } from 'vue'

  import Properties from '../pages/welcome/Properties.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { generateUrl, shuffleArray } from '@shared/util.js'

  const loaded = ref(0)

  const propertiesSalePath = window.app.page.properties_sale_path
  const propertiesRentPath = window.app.page.properties_rent_path

  const { callGet } = useAjax()
  const { vt } = useI18n('welcome.index.js')

  const LOADED_STATUS_AGENCIES = 16
  const LOADED_STATUS_PROPERTIES = 15
  const LOADED_STATUS_SALE_PROPERTIES = 3

  const loadedProperties = computed(() => (loaded.value & LOADED_STATUS_PROPERTIES) > 0)
  const loadedSaleProperties = computed(() => (loaded.value & LOADED_STATUS_PROPERTIES) > 0)

  /**
   * 物件一覧の表示完了イベント
   */
  const handleLoadProperties = (value) => {
    loaded.value |= value
  }
</script>

<template>
  <section id="home-sale" class="home-sale">
    <div class="section_wrap">
      <Properties
        :link="propertiesSalePath"
        :title="vt('newest_listings_for_sale')"
        kind="newest"
        type="sale"
        @load="handleLoadProperties(2)"
      />
    </div>
  </section>

  <section v-if="false" id="home-rent" class="home-rent">
    <div class="section_wrap">
      <Properties
        :link="propertiesRentPath"
        :title="vt('newest_listings_for_rent')"
        :wait="!loadedSaleProperties"
        kind="newest"
        type="rent"
        @load="handleLoadProperties(8)"
      />
    </div>
  </section>
</template>

<style>
@font-face {
    font-family: "Font Awesome 6 Free";
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url(/vendor/main/webfonts/fa-regular-400.woff2) format("woff2"),url(/vendor/main/webfonts/fa-regular-400.ttf) format("truetype")
}

.fa-regular,.far {
    font-weight: 400
}

:host,:root {
    --fa-style-family-classic: "Font Awesome 6 Free";
    --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free"
}

@font-face {
    font-family: "Font Awesome 6 Free";
    font-style: normal;
    font-weight: 900;
    font-display: block;
    src: url(/vendor/main/webfonts/fa-solid-900.woff2) format("woff2"),url(/vendor/main/webfonts/fa-solid-900.ttf) format("truetype")
}

.fa-solid,.fas {
    font-weight: 900
}

#app-widget a {
  transition: 0.3s ease opacity;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: #000;
}

#app-widget h4 {
  margin-top: 0;
  margin-bottom: 0.8rem;
}

#app-widget ul, #app-widget li {
  margin: 0;
  padding: 0;
  list-style: none;
}

#app-widget p {
  margin: 0;
  padding: 0;
}

#app-widget .listing {
  color: #212529;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  font-weight: 400;
  line-height: 1.45;
  /** font-size: 1.6rem; */
  font-size: 1.0rem;
  font-family: "Open Sans", sans-serif;
  box-sizing: border-box;
}

#app-widget .listing h2 {
  font-family: "Shippori Mincho", "Open Sans", sans-serif;
  box-sizing: border-box;
  margin-top: 0;
  line-height: 1.2;
  color: inherit;
  /** font-size: 2.6rem; */
  margin-bottom: 30px;
  text-align: center;
  font-weight: 700;
}

#app-widget .listing .c-slider {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 3.75rem;
  gap: 0;
  padding: 10px 0 10px 10px;
  z-index: 0;
}

#app-widget .listing .c-slider .swiper-button-prev {
  left: 20px;
}

#app-widget .listing .c-slider .swiper-button-disabled {
  display: none;
}

#app-widget .listing .c-slider .swiper-button-next {
  right: 25px;
}

#app-widget .listing .c-slider .swiper-button-next, #app-widget .c-slider .swiper-button-prev {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  margin-top: 0;
  transition: 0.3s ease;
  margin: 0;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

#app-widget .listing .c-slider .swiper-button-next:after, #app-widget .c-slider .swiper-button-prev:after {
  content: "\f105";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  /** font-size: 30px; */
  font-size: 18.75px;
  color: #000;
  opacity: 1;
}

#app-widget .listing .c-slider .swiper-button-prev:after {
  transform: scale(-1, 1);
}

#app-widget .listing .c-slider .item {
  height: auto;
}

#app-widget .listing .item {
  max-width: 300px;
  border: 1px solid #e4e4e4;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;
  height: 100%;
  background-color: #fff;
  transition: 0.3s ease box-shadow;
  position: relative;
}

#app-widget .listing .item a {
  display: block;
  width: 100%;
  height: 100%;
  padding-bottom: 8px;
}

#app-widget .listing .item .photo_label {
  position: relative;
  margin-bottom: 10px;
}

#app-widget .listing .item .photo {
  max-width: 300px;
}

#app-widget .listing .item .photo img {
  width: 100%;
  aspect-ratio: 3 / 2;
  -o-object-fit: cover;
  object-fit: cover;
}

#app-widget .listing .item .place {
  width: 100%;
  /**font-size: 1.4rem;*/
  font-size: 0.875rem;
  line-height: 1.4;
  text-align: center;
  color: #fff;
  position: absolute;
  bottom: 0;
  padding: 10px;
  margin-bottom: 0;
}

#app-widget .listing .item .status {
  position: absolute;
  left: 10px;
  top: 10px;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
}

#app-widget .listing .item .status li {
  /** font-size: 1.3rem; */
  font-size: 0.8125rem;
  color: #fff;
  padding: 2px 6px 1px;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 4px;
}

#app-widget .listing .item .status li.st01 {
  background: #6dc644;
}

#app-widget .listing .item .status li.st02 {
  background: #1a52b8;
}

#app-widget .listing .item .status li.st03 {
  background: #7556F2;
}

#app-widget .listing .item .status li.st03-y {
  background: #c82021;
}

#app-widget .listing .item .status li.st04 {
  background: #c82021;
}

#app-widget .listing .info {
  padding: 0 10px;
}

#app-widget .listing .item .price {
  /** font-size: 2.2rem; */
  font-size: 1.375rem;
  font-weight: 700;
  margin-bottom: 6px;
}

#app-widget .listing .info .detail {
  display: -ms-flexbox;
  display: flex;
  /** font-size: 1.4rem; */
  font-size: 0.875rem;
}

#app-widget .listing .info .detail .icons_info:not(:last-child) {
  margin-right: 8px;
}

#app-widget .listing .info .detail .icons_info {
  /** font-size: 1.4rem; */
  font-size: 0.875rem;
  margin-right: 6px;
  margin-bottom: 0;
}

#app-widget .listing .info .detail .icons_info span {
  font-weight: 700;
  /** font-size: 1.4rem; */
  font-size: 0.875rem;
  display: inline-block;
  margin-right: 2px;
}

#app-widget .listing .info h4 {
  font-family: "Open Sans", sans-serif;
  font-weight: normal;
  /** font-size: 1.4rem; */
  font-size: 0.875rem;
  line-height: 1.5;
}

#app-widget .listing .item.item-view-more {
  background-color: #299bb1;
}

#app-widget .listing .item.item-view-more a {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 100%;
}

#app-widget .listing .item.item-view-more p {
  color: #fff;
  text-align: center;
  font-weight: 700;
}

#app-widget .listing .item.item-view-more p::after {
  content: "\f0a9";
  font-family: "Font Awesome 6 Free";
  text-align: center;
  display: block;
  text-align: center;
  font-size: 2.8rem;
  margin-top: 5px;
}

@media screen and (max-width: 1440px) and (min-width: 993px) {
}

@media screen and (max-width: 992px) and (min-width: 769px) {
}

@media (max-width: 390px) {
}
</style>
